module.exports = __webpack_public_path__ + "img/BannerBackground.33c46a92.png";